var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01322 2.76406C5.52767 2.72301 6.01607 2.52071 6.40887 2.18597C7.32551 1.40481 8.67371 1.40481 9.59035 2.18597C9.98315 2.52071 10.4715 2.72301 10.986 2.76406C12.1865 2.85987 13.1398 3.81318 13.2356 5.01371C13.2767 5.52816 13.479 6.01655 13.8137 6.40936C14.5949 7.326 14.5949 8.67419 13.8137 9.59084C13.479 9.98364 13.2767 10.472 13.2356 10.9865C13.1398 12.187 12.1865 13.1403 10.986 13.2361C10.4715 13.2772 9.98315 13.4795 9.59035 13.8142C8.67371 14.5954 7.32551 14.5954 6.40887 13.8142C6.01607 13.4795 5.52767 13.2772 5.01322 13.2361C3.81269 13.1403 2.85938 12.187 2.76357 10.9865C2.72252 10.472 2.52022 9.98364 2.18548 9.59084C1.40432 8.67419 1.40432 7.326 2.18548 6.40936C2.52022 6.01655 2.72252 5.52816 2.76357 5.01371C2.85938 3.81318 3.81269 2.85987 5.01322 2.76406ZM10.9653 6.96578C11.2777 6.65336 11.2777 6.14683 10.9653 5.83441C10.6529 5.52199 10.1463 5.52199 9.83392 5.83441L7.19961 8.46873L6.16529 7.43441C5.85288 7.12199 5.34634 7.12199 5.03392 7.43441C4.7215 7.74683 4.7215 8.25336 5.03392 8.56578L6.63392 10.1658C6.94634 10.4782 7.45288 10.4782 7.76529 10.1658L10.9653 6.96578Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchased);
export default __webpack_public_path__ + "static/media/purchased.4a299b92c33e582e394666485811f5ab.svg";
export { ForwardRef as ReactComponent };